<template>
    <select data-vselect="true" v-model="content"></select>
</template>

<script>
    export default {
        props: ['options', 'value', 'ajax', 'exceptId'],
        data() {
            let vm = this;

            let response = {
                refreshDelay: null,
                content: this.value,
                settings: {
                    ajax: {},
                    allowClear: false,
                    data: {},
                    templateResult: function (result) {
                        if (result.loading) { return result.text; }
                        if (!result.id && !result.text) { return null; }
                        if (result.id != 'add_new') { return result.text; }

                        return $(`<span>
                            <strong>
                                <i class="fas fa-plus mr-1"></i>
                                ${result.text}
                            </strong>
                        </span>`);
                    }
                }
            };

            if (typeof this.ajax !== 'undefined') {
                response.settings.ajax.url = this.ajax;
            } else {
                response.settings.data = this.options.filter(o => (o.id == vm.value && o.id != null));
            }

            return response;
        },
        mounted() {
            var vm = this;

            setTimeout(function(){
                vm.init();
            }, 100);
        },
        methods:{
            init(){
                let vm = this;
                var id = uniqid();

                $(this.$el).attr("id", id);

                this.select2();

                var id = $(this.$el).attr("id");
                $(this.$el).prev().attr("for", id);
                $(this.$el).next().attr("id", id+"-message");
            },
            maybe_add_option(data) {
                let vm = this;
                if (vm.options === undefined) {
                    return;
                }
                let i = vm.options.length;

                while (i--) {
                    let val = typeof vm.options[i].id == 'undefined' ? vm.options[i]:vm.options[i].id;
                    if (val == vm.content||val == vm.content) {
                        data = vm.options[i];
                    }
                }

                let id = data.id;
                let text = data.text;

                let option = $(this.$el).find("option[value='" + id + "']");
                if (!option.length && id != null && id !== "") {
                    var newOption = new Option(text, id, false, false);
                    $(this.$el).append(newOption);
                }
            },
            select2(){
                let vm = this;
                let sema = false;
                $.fn.select2.amd.require(["select2/data/array", "select2/utils"],
                function (ArrayData, Utils) {
                    function CustomData($element, options) {
                        CustomData.__super__.constructor.call(this, $element, options);
                    }
                    Utils.Extend(CustomData, ArrayData);

                    let pageSize = 25;

                    CustomData.prototype.select = function(data){
                        var self = this;

                        data.selected = true;

                        // If data.element is a DOM node, use it instead
                        if ($(data.element).is('option')) {
                            data.element.selected = true;
                            this.$element.trigger('change');
                            return;
                        }

                        if (this.$element.prop('multiple')) {
                            this.current(function (currentData) {
                                var val = [];
                                data = [data];
                                data.push.apply(data, currentData);

                                for (var d = 0; d < data.length; d++) {
                                    var id = data[d].id;
                                    if ($.inArray(id, val) === -1) {
                                        val.push(id);
                                    }
                                }

                                self.$element.val(val);
                                self.$element.trigger('change');
                            });
                        } else {
                            vm.content = data.id;
                            vm.maybe_add_option(data);
                            vm.$nextTick(function(){
                                self.$element.trigger('change');
                            });
                        }
                    };

                    CustomData.prototype.current = function(callback){
                        let i = vm.options.length;
                        let selected;
                        while (i--) {
                            let val = typeof vm.options[i].id == 'undefined'?vm.options[i]:vm.options[i].id;
                            if (val == vm.content||val == vm.content) {
                                selected = [vm.options[i]];
                            }
                        }

                        if (vm.content == null) selected = [{id: "", text: ""}];
                        if (typeof selected == 'undefined') selected = [{id: vm.content, text: vm.content}];

                        vm.maybe_add_option(selected);
                        callback(selected);
                    };

                    CustomData.prototype.query = function (params, callback) {
                        let selected = "";
                        let items = vm.options.filter((o)=>{
                            if(o.id == vm.content) selected = o;
                            return o.text != null&&o.id!=vm.content;
                        });

                        let results = [];
                        if (params.term && params.term !== '') {
                            results = _.filter(items, function(e) {
                                return (e.text.toUpperCase().indexOf(params.term.toUpperCase()) >= 0);
                            });

                            if($(vm.$el).data("tags")){
                                results.push({id: params.term, text: params.term})
                            }
                        } else {
                            results = items;
                        }

                        if (!("page" in params)) {
                            params.page = 1;
                        }

                        var data = {};
                        data.results = results.slice((params.page - 1) * pageSize, params.page * pageSize);

                        if (params.page==1) data.results.unshift(selected);
                        data.pagination = {};
                        data.pagination.more = params.page * pageSize < results.length;
                        callback(data);
                    };

                    if (typeof vm.ajax == 'undefined') {
                        vm.settings.dataAdapter = CustomData;
                    }

                    $(vm.$el).empty().select2(vm.settings).on("change", function() {
                        vm.content = this.value;
                    }).on("select2:close, select2:select", function() {
                        sema = true;
                        setTimeout(function(){
                            sema = false;
                        }, 250);
                    }).on("select2:open", function (e) {
                        document.querySelector(`[aria-controls="select2-${e.target.id}-results"]`).focus();
                    }).val(vm.value).trigger("change", [true]);
                });

                let selector = $(this.$el).parent();
                selector.on("focus", ".select2", function(e){
                    if (vm.$el.disabled) return;
                    if (e.originalEvent) {
                        if (sema) return;
                        $(vm.$el).select2("open");
                    }
                });
            }
        },
        watch: {
            value(value) {
                this.content = value;
            },
            options: {
                handler(options) {
                    clearTimeout(this.refreshDelay);
                    let vm = this;
                    this.refreshDelay = setTimeout(() => {
                        vm.select2(vm.settings);
                    }, 250);
                },
                deep: true
            },
            content(value, ovalue) {
                this.maybe_add_option({ id:value, text:value });
                this.$emit('input', value);
            },
            exceptId(value) {
                if (value !== undefined) {
                    const exceptQuery = '?except_id=' + value;
                    this.settings.ajax.url = this.ajax + exceptQuery;
                    this.select2();
                }
            }
        },
        destroyed() {
            try {
                $(this.$el).off().select2('destroy');
            } catch (error) {}
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/elements/select2.vue